import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ExamSubjectGradepointsPopComponent } from '../exam-subject-gradepoints-pop/exam-subject-gradepoints-pop.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-exam-subject-popup',
  templateUrl: './exam-subject-popup.component.html',
  styleUrls: ['./exam-subject-popup.component.scss'],
})
export class ExamSubjectPopupComponent implements OnInit {
  ExamSubForm: FormGroup;
  indexa = 1;
  Arr: any = [];
  OptionTable: [];
  DefineTable: [];
  LoginArr: any = [];
  DistPercent = false;
  Updatebtn = false;
  Deletebtn = false;
  Submitbtn = true;
  DistSign = false;
  Group = false;
  ValType = false;
  UniColg = false;
  MaxMarks = false;
  InPart = false;
  OptionGridShow = false;
  Part = false;
  Sec = false;
  Marks = false;
  PassMarks = false;
  PassPercent = false;
  GrdBtn = false;
  DefBtn = false;
  Credits = false;
  Text = false;
  EsGrdPts = '';
  nextTabDisabled = true;
  disableplus = true;
  // ExamMarks = false;
  // ExamPercent = false;
  OptionGrid: FormArray;
  DefineGrid: FormArray;
  marksGrid: FormArray;
  showMark = false;
  showPerc = true;
  selectedoption = 'group';
  selectedOption: any = null;
  selectedRowIndex: number = null;
  optGridAction = [];
  printSelectDropDown = [
    {
      id: 'Y',
      name: 'Y',
    },
    {
      id: 'N',
      name: 'N',
    },
    {
      id: 'H',
      name: 'H',
    },
  ];
  groupList = [
    {
      id: 'group1',
      name: 'Group A',
    },
    {
      id: 'group2',
      name: 'Group B',
    },
    {
      id: 'group2',
      name: 'Group C',
    },
    {
      id: 'group3',
      name: 'Group D',
    },
  ];
  subjectList = [
    {
      id: 'subject1',
      name: 'Subject A',
    },
    {
      id: 'subject2',
      name: 'Subject B',
    },
    {
      id: 'subject2',
      name: 'Subject C',
    },
    {
      id: 'subject3',
      name: 'Subject D',
    },
  ];
  partList = [
    {
      id: 'part1',
      name: 'Part 1',
    },
    {
      id: 'part2',
      name: 'Part B',
    },
    {
      id: 'part3',
      name: 'Part C',
    },
    {
      id: 'part4',
      name: 'Part D',
    },
  ];
  stageone = true;
  stagetwo = false;
  // ExamSubjectForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  CourseType = false;
  SubTotal = false;
  ExclTotal = false;
  CarryOver = false;
  ScaleDown = false;
  value: any;
  Semester = false;
  selectedIndex: number = 0;
  SemList: any;
  filteredListSem: any;
  Title: string;
  Type: string;
  optionList: any;
  CourseList: any;
  filteredListCourse: any;
  ThPrList: any;
  filteredListThPr: any;
  filteredListMustOff: never[];
  EsCodeArr = [];
  cantOffer = [];
  mustOffer = [];
  filteredListSubjects: any;
  ValTypeList: any;
  filteredListVal: any;
  x = this.umsService.examData['EmId'];
  str = this.data.branchId ? this.data.branchId : 0;
  Seq: any;
  level: number;
  payload: any;
  abc: any = [];
  a1: any = [];
  a2: string;
  data1: string;
  CourseName: string;
  ExamName: string;
  a3: any[];
  array: any[];
  filteredListCode: any[];
  EsCodeArr1: any[];
  filteredListCode1: any[];
  EsCodeArr2: any;
  filteredListCode2: any;
  filteredListGroup: any;
  EsGroup: any;
  EsCode: any;
  Code: any;
  disable = false;
  disableDelete = false;
  dialogRef: MatDialogRef<any>;
  countofrow = 0;
  countofrowmarksGrid = 0;
  subCodee;
  grpCode;
  subCodeName;
  grpCodeName;
  subCodeUnderGroup;
  lastInd = false;
  disableLastDefine = false;
  filterlistprintSelectDropDown: { id: string; name: string; }[];
  print: any;
  APIService: any;
  subjects: any;
  userPermission: any;
  utp: any;
  subjectCreate = true;
  subjectUpdate = true;
  subjectDelete = true;
  codeArray: any;
  PaperType = false;
  paperTypeList: any;
  paperTypeListData: any;
  pType: any;
  esCode: any;
  PaperTypeCode: any;
  AttendanceRequired: any;
  constructor(
    private modalPopupService: ModalpopService,
    public umsService: UmsService,
    public dialogRef1: MatDialogRef<ExamSubjectPopupComponent>,
    private httpClient: HttpClient,
    public dialogRefGradePoints: MatDialogRef<ExamSubjectGradepointsPopComponent>,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    this.selectedoption = data.id;
    this.APIService = environment.serviceUrl;
  }

  onClose(response: boolean) {
    this.dialogRef1.close(response);
  }
  ngOnInit(): void {
    
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      this.userPermission.forEach(element => {
        if (element.PageName == 'Subject-setup' && element.PCreate == false) {
          this.subjectCreate = false;
        }
        if (element.PageName == 'Subject-setup' && element.PUpdate == false) {
          this.subjectUpdate = false;
        }
        if (element.PageName == 'Subject-setup' && element.PDelete == false) {
          this.subjectDelete = false;
        }
      });
    }
    this.filterlistprintSelectDropDown = this.printSelectDropDown.slice();
    this.subCodee = this.data.subCodee;
    this.grpCode = this.data.grpCode;
    this.subCodeUnderGroup = this.data.subCodeUnderGroup;
    this.subCodeName = this.data.subCodeName;
    this.grpCodeName = this.data.grpCodeName;
    this.Updatebtn = false;
    this.Deletebtn = false;
    this.Submitbtn = true;
    this.ExamSubForm = this.fb.group({
      Inst: new FormControl(this.umsService.secretdata['ClubPartTrans']),
      EsId: new FormControl(''),
      EsStrId: new FormControl(''),
      EsEmId: new FormControl(),
      EsType: new FormControl(''),
      EsSeq: new FormControl(''),
      EsLevel: new FormControl(''),
      EsCode: new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-z0-9-]*$'),
      ]),
      EsShName: new FormControl('', [Validators.required]),
      EsLang: new FormControl(''),
      EsName: new FormControl('', [Validators.required]),
      ESubOption: new FormControl(''),
      EsPrint: new FormControl('Y', [Validators.required]),
      ESubParent: new FormControl(''),
      EsCombCode: new FormControl(''),
      EsNoComb: new FormControl(''),
      EsMarkGrd: new FormControl('M', Validators.required,),
      EsCollUni: new FormControl('U', [Validators.required,
      Validators.pattern('^[a-z A-Z-& ,. \\s]*$'),
      ]),
      EsACF: new FormControl(''),
      EsExclTot: new FormControl(''),
      EsSpFlag: new FormControl(''),
      EsMaxMarks: new FormControl('', Validators.pattern('^[0-9]*$')),
      EsPartMarks: new FormControl('', Validators.pattern('^[0-9]*$')),
      EsQMarks: new FormControl(''),
      EsPassMarks: new FormControl('', Validators.pattern('^[0-9]*$')),
      EsPassPC: new FormControl(''),
      EsExmMarks: new FormControl('', Validators.pattern('^[0-9]*$')),
      EsExmPC: new FormControl(''),
      EsMustPass: new FormControl(''),
      EsDistMarks: new FormControl('', Validators.pattern('^[0-9]*$')),
      EsDistPC: new FormControl('',),
      EsDistRem: new FormControl('', Validators.pattern('^[a-zA-Z]*$')),
      EsPSubId: new FormControl(''),
      ESUBID: new FormControl(''),
      PType: new FormControl(''),
      NotPrintAdmitCrd: new FormControl(''),
      AttendanceRequired: new FormControl(''),
      EsParent: new FormControl(''),
      ESubPart: new FormControl(''),
      ESubInPart: new FormControl(''),
      ESubGroup: new FormControl(''),
      EsCoType: new FormControl(''),
      EsThPr: new FormControl(''),
      EsSubTot: new FormControl(''),
      EsSeSr: new FormControl(''),
      EsOldCode: new FormControl(''),
      OpCode: new FormControl('', Validators.pattern('^[a-zA-Z]*$')),
      OpSpFlag: new FormControl(''),
      OpMin: new FormControl(''),
      OpMax: new FormControl(''),
      // ^([A-F]\+)|([A-F])$
      // ^([A-Za-z]\+)|([A-Za-z])$
      // EsGrd: new FormControl('',[Validators.pattern('^([A-Za-z]\+)|([A-Za-z])$')]),
      EsPass: new FormControl(''),
      EsExm: new FormControl(''),
      // EsMrk: new FormControl('',[Validators.pattern('^[0-9]+$')]),
      EsHOM: new FormControl('Y'),
      EsCredit: new FormControl('', [
        Validators.pattern('^((100)|([0-9]{1,2}(.[0-9]*)?))$'),
        Validators.max(100),
      ]),
      EsGrdPts: new FormControl(''),
      EsDeAct: new FormControl(''),
      EsGrades: new FormControl(''),
      CDMARKPERCENTAGE: new FormControl(true),
      Action: new FormControl(),
      EsOpCode: new FormControl(''),
      OptionGrid: new FormArray([]),
      DefineGrid: new FormArray([]),
      marksGrid: new FormArray([]),
      LoginId: new FormControl(''),
    });

    // this.showPaperT();
    this.showCourseT();
    this.showSubTotal();
    this.showSem();
    this.showTitle();
    this.showType();
    this.Groups();
    this.ListOfAllSubjects();
    this.Subjects();
    this.HomConditions();
    this.ValTypeData();
    this.showGrade();
    // this.emptyOption();
    // this.addnewrow();
    this.getOptionData();
    this.addnewDefine();
    this.CourseName = this.umsService.courseData['CoName'];
    this.ExamName = this.umsService.examData['EmName'];
    this.ExamSubForm.controls['LoginId'].setValue(sessionStorage.getItem('userId'));
    //  this.ExamSubForm.controls['EsMaxMarks'].setValue(0);
    if (this.data.type == 'new') {
      this.ExamSubForm.controls['EsPrint'].setValue('Y');
      this.ExamSubForm.controls['EsMarkGrd'].setValue('M');
      this.ExamSubForm.controls['EsCollUni'].setValue('U');
    } else {

    }

  }
  getOptionGridControls() {
    return (this.ExamSubForm.get('OptionGrid') as FormArray).controls;
  }
  getDefineGridControls() {
    return (this.ExamSubForm.get('DefineGrid') as FormArray).controls;
  }
  getmarksGridControls() {
    return (this.ExamSubForm.get('marksGrid') as FormArray).controls;
  }

  next() {
    this.stageone = false;
    this.stagetwo = true;
  }

  public nextTab() {

    if (this.selectedoption == 'S' || this.Type == 'S') {
      if (this.ExamSubForm.get('EsCode').valid == true && this.ExamSubForm.get('EsShName').valid == true && this.ExamSubForm.get('EsName').valid == true && this.ExamSubForm.get('EsPrint').valid == true) {
        this.selectedIndex += 1;
        this.nextTabDisabled = false;
      } else {
        this.ExamSubForm.get('EsCode').markAsTouched();
        this.ExamSubForm.get('EsShName').markAsTouched();
        this.ExamSubForm.get('EsName').markAsTouched();
        this.ExamSubForm.get('EsPrint').markAsTouched();
      }
    } else if (this.selectedoption == 'G') {
      if (this.ExamSubForm.get('EsCode').valid == true && this.ExamSubForm.get('EsName').valid == true && this.ExamSubForm.get('EsPrint').valid == true) {
        this.selectedIndex += 1;
        this.nextTabDisabled = false;
      } else {
        this.ExamSubForm.get('EsCode').markAsTouched();
        this.ExamSubForm.get('EsName').markAsTouched();
        this.ExamSubForm.get('EsPrint').markAsTouched();
      }
    } else if (this.selectedoption !== 'S') {
      if (this.ExamSubForm.get('ESUBID').valid == true && this.ExamSubForm.get('EsCode').valid == true && this.ExamSubForm.get('EsName').valid == true && this.ExamSubForm.get('EsPrint').valid == true) {
        this.selectedIndex += 1;
        this.nextTabDisabled = false;
      } else {
        this.ExamSubForm.get('ESUBID').markAsTouched();
        this.ExamSubForm.get('EsCode').markAsTouched();
        // this.ExamSubForm.get('EsShName').markAsTouched();
        this.ExamSubForm.get('EsName').markAsTouched();
        this.ExamSubForm.get('EsPrint').markAsTouched();
      }
    }
  }
  prevTab() {
    this.selectedIndex -= 1;
  }

  // showPaperT() {
  //   if (
  //     this.umsService.examData['EmElgblCd'] == 'ThPr' ||
  //     this.umsService.examData['EmDivFirstMrk'] == 'ThPr'
  //   ) {
  //     this.PaperType = true;
  //     this.umsService.getThPr().subscribe((res) => {
  //       if (res.status == true) {
  //         this.ThPrList = res.data;
  //         this.filteredListThPr = this.ThPrList.slice();
  //       } else {
  //         this.CourseType = false;
  //       }
  //     });
  //   } else {
  //     this.PaperType = false;
  //   }
  // }
  showCourseT() {
    this.umsService.getGetCode().subscribe((res) => {
      if (res.status == true) {
        this.CourseType = true;
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      } else {
        this.CourseType = false;
      }
    });
  }

  showSubTotal() {
    if (this.umsService.examData['EmSubTot'] != '') {
      this.SubTotal = true;
      this.value = this.umsService.examData['EmSubTot'];
    } else {
      this.SubTotal = false;
    }
  }

  showTitle() {
    if (this.data.value.EsType == 'S' || this.selectedoption == 'S') {
      this.OptionGridShow = true
      this.Title = 'Subject';
      this.DistPercent = true;
      this.DistSign = true;
      this.ExclTotal = true;
      this.ScaleDown = false;
      this.level = 0;
      // this.ExamSubForm.get('ESubInPart').setValue(this.ExamSubForm.value['EsParent'])
    } else if (this.data.value.EsType == 'G' || this.selectedoption == 'G') {
      this.Title = 'Group';
      this.OptionGridShow = true;
      this.DistPercent = false;
      this.DistSign = false;
      this.ExclTotal = false;
      this.ScaleDown = false;
      this.level = 0;
    } else if (this.data.value.EsType == 'P' || this.selectedoption == 'P') {
      this.Title = 'Part';
      this.DistPercent = false;
      this.OptionGridShow = false;
      this.DistSign = false;
      this.ExclTotal = true;
      this.ScaleDown = false;
      this.level = 1;
      this.fetchPaperType()
      // this.ExamSubForm.get('ESubInPart').setValue(this.ExamSubForm.value['EsParent'])
    } else if (this.data.value.EsType == 'I' || this.selectedoption == 'I') {
      this.Title = 'In-Part';
      this.DistPercent = false;
      this.DistSign = false;
      this.OptionGridShow = false;
      this.ExclTotal = false;
      this.ScaleDown = false;
      // this.InPart = true;
      this.level = 2;
      // this.ExamSubForm.get('ESubInPart').setValue(this.ExamSubForm.value['EsParent'])
    } else if (this.data.value.EsType == 'H' || this.selectedoption == 'H') {
      this.fetchPaperType()
      this.Title = 'Head';
      this.DistPercent = false;
      this.DistSign = false;
      this.OptionGridShow = false
      this.ExclTotal = true;
      this.ScaleDown = true;
      this.level = 2;
      // this.ExamSubForm.get('ESubInPart').setValue(this.ExamSubForm.value['EsParent'])
    } else {
    }
  }

  setgroupParentID(e) {
    this.ExamSubForm.get('EsParent').setValue(e);
    // this.ExamSubForm.get('ESubInPart').setValue(this.ExamSubForm.value['EsParent'])
  }
  prepopulate() {

    this.filterlistprintSelectDropDown = this.printSelectDropDown.slice();
    // this.spinner.show();
    this.Updatebtn = true;
    this.Deletebtn = false;
    this.Submitbtn = false;
    this.disable = true;
    this.disableDelete = false
    this.nextTabDisabled = false;
    let Lang = false;
    if (this.data.value.EsLang == 1) {
      Lang = true
    } else {
      Lang = false
    }
    let EsACF = false;
    if (this.data.value.EsACF == 1) {
      EsACF = true
    } else {
      EsACF = false
    }
    let gEsGrades = this.data.value.EsGrades.replace("---", "");

    this.ExamSubForm = this.fb.group({
      Inst: new FormControl(this.umsService.secretdata['ClubPartTrans']),
      EsId: new FormControl(this.data.value.EsId),
      EsStrId: new FormControl(this.data.value.EsStrId),
      EsEmId: new FormControl(this.data.value.EsEmId),
      EsLevel: new FormControl(this.data.value.EsLevel),
      EsSeq: new FormControl(this.data.value.EsSeq),
      EsType: new FormControl(this.data.value.EsType),
      EsCode: new FormControl(this.data.value.EsCode, [
        Validators.required,
        Validators.pattern('^[a-zA-z0-9-]*$'),
      ]),
      EsShName: new FormControl(this.data.value.EsShName, [
        Validators.required,
      ]),
      EsLang: new FormControl(Lang),
      EsName: new FormControl(this.data.value.EsName, [Validators.required]),
      PType: new FormControl(this.data.value.PaperType),
      NotPrintAdmitCrd: new FormControl(this.data.value.NotPrintAdmitCrd == 1 ? true : false),
      AttendanceRequired: new FormControl(this.data.value.AttendanceRequired == 1 ? true : false),
      ESubOption: new FormControl(''),
      EsPrint: new FormControl(this.data.value.EsPrint, [Validators.required]),
      ESubParent: new FormControl(''),
      EsCombCode: new FormControl(this.data.value.EsCombCode),
      EsNoComb: new FormControl(this.data.value.EsNoComb),
      EsPSubId: new FormControl(this.data.value.EsPSubId),
      EsParent: new FormControl(this.data.value.EsParent),
      ESubPart: new FormControl(''),
      ESubInPart: new FormControl(''),
      ESubGroup: new FormControl(''),
      EsCoType: new FormControl(this.data.value.EsCoType),
      EsThPr: new FormControl(this.data.value.EsThPr),
      EsSubTot: new FormControl(this.data.value.EsSubTot),
      EsSeSr: new FormControl(this.data.value.EsSeSr),
      EsOldCode: new FormControl(this.data.value.EsOldCode),
      EsMarkGrd: new FormControl(this.data.value.EsMarkGrd, Validators.required,),
      EsCollUni: new FormControl(this.data.value.EsCollUni, [Validators.required,
      Validators.pattern('^[a-z A-Z-& ,. \\s]*$'),
      ]),
      EsACF: new FormControl(EsACF),
      EsExclTot: new FormControl(this.data.value.EsExclTot == 'Y' ? true : false),
      EsSpFlag: new FormControl(this.data.value.EsSpFlag),
      EsMaxMarks: new FormControl(this.data.value.EsMaxMarks, Validators.pattern('^[0-9]*$')),
      EsPartMarks: new FormControl(this.data.value.EsPartMarks, Validators.pattern('^[0-9]*$')),
      EsQMarks: new FormControl(this.data.value.EsQMarks),
      EsPassMarks: new FormControl(this.data.value.EsPassMarks, Validators.pattern('^[0-9]*$')),
      EsPassPC: new FormControl(this.data.value.EsPassPC),
      EsExmMarks: new FormControl(this.data.value.EsExmMarks, Validators.pattern('^[0-9]*$')),
      EsExmPC: new FormControl(this.data.value.EsExmPC),
      EsMustPass: new FormControl(this.data.value.EsMustPass),
      EsDistMarks: new FormControl(this.data.value.EsDistMarks, Validators.pattern('^[0-9]*$')),
      EsDistPC: new FormControl(this.data.value.EsDistPC),
      EsDistRem: new FormControl(this.data.value.EsDistRem, Validators.pattern('^[a-zA-Z]*$')),
      EsHOM: new FormControl(this.data.value.EsHOM),
      EsCredit: new FormControl(this.data.value.EsCredit, [
        Validators.pattern('^((100)|([0-9]{1,2}(.[0-9]*)?))$'),
        Validators.max(100),
      ]),
      EsGrdPts: new FormControl(this.data.value.EsGrdPts),
      EsDeAct: new FormControl(this.data.value.EsDeAct),
      EsGrades: new FormControl(gEsGrades),
      CDMARKPERCENTAGE: new FormControl(true),
      ESUBID: new FormControl(''),
      // Action: new FormControl(),
      EsOpCode: new FormControl(''),
      OptionGrid: new FormArray([]),
      DefineGrid: new FormArray([]),
      marksGrid: new FormArray([]),
      LoginId: new FormControl(sessionStorage.getItem('userId'))
    });
    this.getDefineData();
    this.marksprepopulate(this.data.value.EsQMarks)
    if (this.data.value.EsHOM == 'Y') {
      this.ValType = true;
      this.UniColg = true;
      this.CarryOver = true;
      this.MaxMarks = true;
      this.PassMarks = true;
      this.PassPercent = true;
    } else if (this.data.value.EsHOM == '') {
      this.ValType = false;
      this.UniColg = false;
      this.CarryOver = false;
      this.MaxMarks = false;
      this.PassMarks = false;
      this.PassPercent = false;
    }
    if (this.Type == 'S') {
      this.ExamSubForm.get('ESubGroup').setValue(this.data.value.EsParent);
      // this.spinner.hide();
    } else if (this.Type == 'P') {
      const payload = {};
      payload['EsParent'] = this.data.value.EsParent;
      payload['EsStrId'] = this.str;
      this.umsService.getParentRecord(payload).subscribe((res) => {
        // this.spinner.hide();
        this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsId);
      });
      // this.ExamSubForm.get('ESubGroup').setValue(this.data.value.EsParent);
    } else if (this.Type == 'I') {
      const payload = {};
      payload['EsParent'] = this.data.value.EsParent;
      payload['EsStrId'] = this.str;
      this.umsService.getParentRecord(payload).subscribe((res) => {
        // this.spinner.hide();
        if (res.data[0].EsType == 'P') {
          // this.spinner.hide();
          this.EsCodeArr1 = [];
          this.EsCodeArr2 = [];
          this.Part = false;
          this.InPart = false;
          payload['EsStrId'] = this.str;
          payload['EsId'] = res.data[0].EsParent;
          this.umsService.getSingleRecord(payload).subscribe((res) => {
            // this.spinner.hide();
            if (res.status) {
              res.data.forEach((element) => {
                if (element.EsType == 'P') {
                  this.EsCodeArr1.push(element);
                  this.filteredListCode1 = this.EsCodeArr1.slice();
                  this.Part = true;
                  this.PaperType = true
                }
                if (element.EsType == 'I') {
                  this.EsCodeArr2.push(element);
                  this.filteredListCode2 = this.EsCodeArr2.slice();
                  this.InPart = true;
                }
              });
            } else {
              // this.spinner.hide();
            }
          });
          this.ExamSubForm.get('ESubPart').setValue(res.data[0].EsId);
          this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsParent);
        } else if (res.data[0].EsType == 'S') {
          this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsId);
          // this.spinner.hide();
        }
      });
    } else if (this.Type == 'H') {
      const payload = {};
      payload['EsParent'] = this.data.value.EsParent;
      payload['EsStrId'] = this.str;
      this.umsService.getParentRecord(payload).subscribe((res) => {
        // this.spinner.hide();
        if (res.data[0].EsType == 'I') {
          const payload = {};
          payload['EsParent'] = res.data[0].EsParent;
          payload['EsStrId'] = this.str;
          this.umsService.getParentRecord(payload).subscribe((res) => {
            // this.spinner.hide();
            if (res.data[0].EsType == 'P') {
              this.EsCodeArr1 = [];
              this.EsCodeArr2 = [];
              this.Part = false;
              this.InPart = false;
              payload['EsStrId'] = this.str;
              payload['EsId'] = res.data[0].EsParent;
              this.umsService.getSingleRecord(payload).subscribe((res) => {
                // this.spinner.hide();
                if (res.status) {
                  res.data.forEach((element) => {
                    if (element.EsType == 'P') {
                      this.EsCodeArr1.push(element);
                      this.filteredListCode1 = this.EsCodeArr1.slice();
                      this.Part = true;
                      this.PaperType = true
                    }
                  });
                } else {
                  // this.spinner.hide();
                }
              });
              payload['EsStrId'] = this.str;
              payload['EsId'] = res.data[0].EsId;
              this.umsService.getSingleRecord(payload).subscribe((res) => {
                // this.spinner.hide();
                if (res.status) {
                  res.data.forEach((element) => {
                    if (element.EsType == 'I') {
                      this.EsCodeArr2.push(element);
                      this.filteredListCode2 = this.EsCodeArr2.slice();
                      this.InPart = true;
                    }
                  });
                } else {

                  // this.spinner.hide();
                }
              });
              this.ExamSubForm.get('ESubPart').setValue(res.data[0].EsId);
              this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsParent);
            } else if (res.data[0].EsType == 'I') {
              this.EsCodeArr1 = [];
              this.EsCodeArr2 = [];
              this.Part = false;
              this.InPart = false;
              payload['EsStrId'] = this.str;
              payload['EsId'] = res.data[0].EsId;
              this.umsService.getSingleRecord(payload).subscribe((res) => {
                // this.spinner.hide();
                if (res.status) {
                  res.data.forEach((element) => {
                    if (element.EsType == 'P') {
                      this.EsCodeArr1.push(element);
                      this.filteredListCode1 = this.EsCodeArr1.slice();
                      this.Part = true;
                      this.PaperType = true
                    }
                    if (element.EsType == 'I') {
                      this.EsCodeArr2.push(element);
                      this.filteredListCode2 = this.EsCodeArr2.slice();
                      this.InPart = true;
                    }
                  });
                } else {
                  // this.spinner.hide();
                }
              });
              this.ExamSubForm.get('ESubPart').setValue(res.data[0].EsId);
              this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsParent);
            } else if (res.data[0].EsType == 'S') {
              this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsId);
              this.EsCodeArr1 = [];
              this.EsCodeArr2 = [];
              this.Part = false;
              this.InPart = false;
              payload['EsStrId'] = this.str;
              payload['EsId'] = res.data[0].EsId;
              this.umsService.getSingleRecord(payload).subscribe((res) => {
                // this.spinner.hide();
                if (res.status) {
                  res.data.forEach((element) => {
                    if (element.EsType == 'P') {
                      this.EsCodeArr1.push(element);
                      this.filteredListCode1 = this.EsCodeArr1.slice();
                      this.Part = true;
                      this.PaperType = true
                    }
                    if (element.EsType == 'I') {
                      this.EsCodeArr2.push(element);
                      this.filteredListCode2 = this.EsCodeArr2.slice();
                      this.InPart = true;
                    }
                  });
                } else {
                  // this.spinner.hide();
                }
              });
            }
          });
          this.ExamSubForm.get('ESubInPart').setValue(res.data[0].EsId)
        } else if (res.data[0].EsType == 'P') {
          const payload = {};
          payload['EsParent'] = res.data[0].EsParent;
          payload['EsStrId'] = this.str;
          this.umsService.getParentRecord(payload).subscribe((res) => {
            // this.spinner.hide();
            if (res.data[0].EsType == 'P') {
              this.EsCodeArr1 = [];
              this.EsCodeArr2 = [];
              this.Part = false;
              this.InPart = false;
              payload['EsStrId'] = this.str;
              payload['EsId'] = res.data[0].EsId;
              this.umsService.getSingleRecord(payload).subscribe((res) => {
                // this.spinner.hide();
                if (res.status) {
                  res.data.forEach((element) => {
                    if (element.EsType == 'P') {
                      this.EsCodeArr1.push(element);
                      this.filteredListCode1 = this.EsCodeArr1.slice();
                      this.Part = true;
                      this.PaperType = true
                    }
                    if (element.EsType == 'I') {
                      this.EsCodeArr2.push(element);
                      this.filteredListCode2 = this.EsCodeArr2.slice();
                      this.InPart = true;
                    }
                  });
                } else {
                }
              });
              this.ExamSubForm.get('ESubPart').setValue(res.data[0].EsId);
              this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsParent);
            } else if (res.data[0].EsType == 'I') {
              this.EsCodeArr1 = [];
              this.EsCodeArr2 = [];
              this.Part = false;
              this.InPart = false;
              payload['EsStrId'] = this.str;
              payload['EsId'] = res.data[0].EsId;
              this.umsService.getSingleRecord(payload).subscribe((res) => {
                // this.spinner.hide();
                if (res.status) {
                  res.data.forEach((element) => {
                    if (element.EsType == 'P') {
                      this.EsCodeArr1.push(element);
                      this.filteredListCode1 = this.EsCodeArr1.slice();
                      this.Part = true;
                      this.PaperType = true
                    }
                    if (element.EsType == 'I') {
                      this.EsCodeArr2.push(element);
                      this.filteredListCode2 = this.EsCodeArr2.slice();
                      this.InPart = true;
                    }
                  });
                } else {
                }
              });
              this.ExamSubForm.get('ESubPart').setValue(res.data[0].EsId);
              this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsParent);
            } else if (res.data[0].EsType == 'S') {
              this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsId);
              this.EsCodeArr1 = [];
              this.EsCodeArr2 = [];
              this.Part = false;
              this.InPart = false;
              payload['EsStrId'] = this.str;
              payload['EsId'] = res.data[0].EsId;
              this.umsService.getSingleRecord(payload).subscribe((res) => {
                // this.spinner.hide();
                if (res.status) {
                  res.data.forEach((element) => {
                    if (element.EsType == 'P') {
                      this.EsCodeArr1.push(element);
                      this.filteredListCode1 = this.EsCodeArr1.slice();
                      this.Part = true;
                      this.PaperType = true
                    }
                    if (element.EsType == 'I') {
                      this.EsCodeArr2.push(element);
                      this.filteredListCode2 = this.EsCodeArr2.slice();
                      this.ExamSubForm.get('PType').setValue(element.PaperType);
                      this.InPart = true;
                    }
                  });
                } else {
                }
              });
            }
          });
          this.ExamSubForm.get('ESubPart').setValue(res.data[0].EsId)
        } else if (res.data[0].EsType == 'S') {
          const payload = {};
          payload['EsParent'] = this.data.value.EsParent;
          payload['EsStrId'] = this.str;
          this.umsService.getParentRecord(payload).subscribe((res) => {
            this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsId);
          });
        }
      });
    }
  }

  showType() {
    // if(this.data.type == 'new')
    if (this.data.value.EsType == 'S' && this.data.type == 'edit') {
      this.Type = 'S';
      this.prepopulate();
    } else if (this.data.value.EsType == 'G' && this.data.type == 'edit') {
      this.Type = 'G';
      this.prepopulate();
    } else if (this.data.value.EsType == 'P' && this.data.type == 'edit') {
      this.Type = 'P';
      this.prepopulate();
    } else if (this.data.value.EsType == 'I' && this.data.type == 'edit') {
      this.Type = 'I';
      this.prepopulate();
    } else if (this.data.value.EsType == 'H' && this.data.type == 'edit') {
      this.Type = 'H';
      this.prepopulate();
    }
    else if (this.data.value.EsType == 'S' && this.data.type == 'delete') {
      this.Type = 'S';
      // this.prepopulateDelete()
      this.delete();
    }
    else if (this.data.value.EsType == 'G' && this.data.type == 'delete') {
      this.Type = 'G';
      // this.prepopulateDelete();
      this.delete();
    } else if (this.data.value.EsType == 'P' && this.data.type == 'delete') {
      this.Type = 'P';
      // this.prepopulateDelete();
      this.delete();
    } else if (this.data.value.EsType == 'I' && this.data.type == 'delete') {
      this.Type = 'I';
      // this.prepopulateDelete();
      this.delete();
    } else if (this.data.value.EsType == 'H' && this.data.type == 'delete') {
      this.Type = 'H';
      // this.prepopulateDelete();
      this.delete();
    } else if (
      this.selectedoption == 'H' ||
      this.selectedoption == 'I' ||
      this.selectedoption == 'P' ||
      this.selectedoption == 'G' ||
      this.selectedoption == 'S'
    ) {
      this.ExamSubForm.reset();
    }
  }

  prepopulateDelete() {
    this.filterlistprintSelectDropDown = this.printSelectDropDown.slice();
    // this.spinner.show();
    this.Updatebtn = false;
    this.Deletebtn = true;
    this.Submitbtn = false;
    this.disable = false;
    this.disableDelete = true;
    this.nextTabDisabled = false;
    let Lang = false;
    if (this.data.value.EsLang == 1) {
      Lang = true
    } else {
      Lang = false
    }
    let EsACF = false;
    if (this.data.value.EsACF == 1) {
      EsACF = true
    } else {
      EsACF = false
    }
    let gEsGrades = this.data.value.EsGrades.replace("---", "");

    this.ExamSubForm = this.fb.group({
      Inst: new FormControl(this.umsService.secretdata['ClubPartTrans']),
      EsId: new FormControl(this.data.value.EsId),
      EsStrId: new FormControl(this.data.value.EsStrId),
      EsEmId: new FormControl(this.data.value.EsEmId),
      EsLevel: new FormControl(this.data.value.EsLevel),
      EsSeq: new FormControl(this.data.value.EsSeq),
      EsType: new FormControl(this.data.value.EsType),
      PType: new FormControl(this.data.value.PaperType),
      EsCode: new FormControl(this.data.value.EsCode, [
        Validators.required,
        Validators.pattern('^[a-zA-z0-9-]*$'),
      ]),
      EsShName: new FormControl(this.data.value.EsShName, [
        Validators.required,
      ]),
      EsLang: new FormControl(Lang),
      EsName: new FormControl(this.data.value.EsName, [Validators.required]),
      ESubOption: new FormControl(''),
      EsPrint: new FormControl(this.data.value.EsPrint, [Validators.required]),
      ESubParent: new FormControl(''),
      EsCombCode: new FormControl(this.data.value.EsCombCode),
      EsNoComb: new FormControl(this.data.value.EsNoComb),
      EsPSubId: new FormControl(this.data.value.EsPSubId),
      EsParent: new FormControl(this.data.value.EsParent),
      ESubPart: new FormControl(''),
      ESubInPart: new FormControl(''),
      ESubGroup: new FormControl(''),
      EsCoType: new FormControl(this.data.value.EsCoType),
      EsThPr: new FormControl(this.data.value.EsThPr),
      EsSubTot: new FormControl(this.data.value.EsSubTot),
      EsSeSr: new FormControl(this.data.value.EsSeSr),
      EsOldCode: new FormControl(this.data.value.EsOldCode),
      EsMarkGrd: new FormControl(this.data.value.EsMarkGrd, Validators.required,),
      EsCollUni: new FormControl(this.data.value.EsCollUni, [Validators.required,
      Validators.pattern('^[a-z A-Z-& ,. \\s]*$'),
      ]),
      EsACF: new FormControl(EsACF),
      EsExclTot: new FormControl(this.data.value.EsExclTot == 'Y' ? true : false),
      EsSpFlag: new FormControl(this.data.value.EsSpFlag),
      EsMaxMarks: new FormControl(this.data.value.EsMaxMarks, Validators.pattern('^[0-9]*$')),
      EsPartMarks: new FormControl(this.data.value.EsPartMarks, Validators.pattern('^[0-9]*$')),
      EsQMarks: new FormControl(this.data.value.EsQMarks),
      EsPassMarks: new FormControl(this.data.value.EsPassMarks, Validators.pattern('^[0-9]*$')),
      EsPassPC: new FormControl(this.data.value.EsPassPC),
      EsExmMarks: new FormControl(this.data.value.EsExmMarks, Validators.pattern('^[0-9]*$')),
      EsExmPC: new FormControl(this.data.value.EsExmPC),
      EsMustPass: new FormControl(this.data.value.EsMustPass),
      EsDistMarks: new FormControl(this.data.value.EsDistMarks, Validators.pattern('^[0-9]*$')),
      EsDistPC: new FormControl(this.data.value.EsDistPC),
      EsDistRem: new FormControl(this.data.value.EsDistRem, Validators.pattern('^[a-zA-Z]*$')),
      EsHOM: new FormControl(this.data.value.EsHOM),
      EsCredit: new FormControl(this.data.value.EsCredit, [
        Validators.pattern('^((100)|([0-9]{1,2}(.[0-9]*)?))$'),
        Validators.max(100),
      ]),
      EsGrdPts: new FormControl(this.data.value.EsGrdPts),
      EsDeAct: new FormControl(this.data.value.EsDeAct),
      EsGrades: new FormControl(gEsGrades),
      CDMARKPERCENTAGE: new FormControl(true),
      ESUBID: new FormControl(''),
      // Action: new FormControl(),
      EsOpCode: new FormControl(''),
      OptionGrid: new FormArray([]),
      DefineGrid: new FormArray([]),
      marksGrid: new FormArray([]),
      LoginId: new FormControl(sessionStorage.getItem('userId'))
    });
    // this.ExamSubForm.controls['EsPrint'].setValue(this.data.value.EsPrint);
    // this.ExamSubForm.controls['EsMarkGrd'].setValue(this.data.value.EsMarkGrd); 
    // this.ExamSubForm.controls['EsCollUni'].setValue(this.data.value.EsCollUni);

    this.getDefineData();
    this.marksprepopulate(this.data.value.EsQMarks)
    if (this.data.value.EsHOM == 'Y') {
      this.ValType = true;
      this.UniColg = true;
      this.CarryOver = true;
      this.MaxMarks = true;
      this.PassMarks = true;
      this.PassPercent = true;
    } else if (this.data.value.EsHOM == '') {
      this.ValType = false;
      this.UniColg = false;
      this.CarryOver = false;
      this.MaxMarks = false;
      this.PassMarks = false;
      this.PassPercent = false;
    }
    if (this.Type == 'S') {
      this.ExamSubForm.get('ESubGroup').setValue(this.data.value.EsParent);
      // this.spinner.hide();
    } else if (this.Type == 'P') {
      const payload = {};
      payload['EsParent'] = this.data.value.EsParent;
      payload['EsStrId'] = this.str;
      this.umsService.getParentRecord(payload).subscribe((res) => {
        // this.spinner.hide();
        this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsId);
      });
      // this.ExamSubForm.get('ESubGroup').setValue(this.data.value.EsParent);
    } else if (this.Type == 'I') {
      const payload = {};
      payload['EsParent'] = this.data.value.EsParent;
      payload['EsStrId'] = this.str;
      this.umsService.getParentRecord(payload).subscribe((res) => {
        // this.spinner.hide();
        if (res.data[0].EsType == 'P') {
          // this.spinner.hide();
          this.EsCodeArr1 = [];
          this.EsCodeArr2 = [];
          this.Part = false;
          this.InPart = false;
          payload['EsStrId'] = this.str;
          payload['EsId'] = res.data[0].EsParent;
          this.umsService.getSingleRecord(payload).subscribe((res) => {
            // this.spinner.hide();
            if (res.status) {
              res.data.forEach((element) => {
                if (element.EsType == 'P') {
                  this.EsCodeArr1.push(element);
                  this.filteredListCode1 = this.EsCodeArr1.slice();
                  this.Part = true;
                  this.PaperType = true
                }
                if (element.EsType == 'I') {
                  this.EsCodeArr2.push(element);
                  this.filteredListCode2 = this.EsCodeArr2.slice();
                  this.InPart = true;
                }
              });
            } else {
              // this.spinner.hide();
            }
          });
          this.ExamSubForm.get('ESubPart').setValue(res.data[0].EsId);
          this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsParent);
        } else if (res.data[0].EsType == 'S') {
          this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsId);
          // this.spinner.hide();
        }
      });
    } else if (this.Type == 'H') {
      const payload = {};
      payload['EsParent'] = this.data.value.EsParent;
      payload['EsStrId'] = this.str;
      this.umsService.getParentRecord(payload).subscribe((res) => {
        // this.spinner.hide();
        if (res.data[0].EsType == 'I') {
          const payload = {};
          payload['EsParent'] = res.data[0].EsParent;
          payload['EsStrId'] = this.str;
          this.umsService.getParentRecord(payload).subscribe((res) => {
            // this.spinner.hide();
            if (res.data[0].EsType == 'P') {
              this.EsCodeArr1 = [];
              this.EsCodeArr2 = [];
              this.Part = false;
              this.InPart = false;
              payload['EsStrId'] = this.str;
              payload['EsId'] = res.data[0].EsParent;
              this.umsService.getSingleRecord(payload).subscribe((res) => {
                // this.spinner.hide();
                if (res.status) {
                  res.data.forEach((element) => {
                    if (element.EsType == 'P') {
                      this.EsCodeArr1.push(element);
                      this.filteredListCode1 = this.EsCodeArr1.slice();
                      this.Part = true;
                      this.PaperType = true
                    }
                  });
                } else {
                  // this.spinner.hide();
                }
              });
              payload['EsStrId'] = this.str;
              payload['EsId'] = res.data[0].EsId;
              this.umsService.getSingleRecord(payload).subscribe((res) => {
                // this.spinner.hide();
                if (res.status) {
                  res.data.forEach((element) => {
                    if (element.EsType == 'I') {
                      this.EsCodeArr2.push(element);
                      this.filteredListCode2 = this.EsCodeArr2.slice();
                      this.InPart = true;
                    }
                  });
                } else {

                  // this.spinner.hide();
                }
              });
              this.ExamSubForm.get('ESubPart').setValue(res.data[0].EsId);
              this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsParent);
            } else if (res.data[0].EsType == 'I') {
              this.EsCodeArr1 = [];
              this.EsCodeArr2 = [];
              this.Part = false;
              this.InPart = false;
              payload['EsStrId'] = this.str;
              payload['EsId'] = res.data[0].EsId;
              this.umsService.getSingleRecord(payload).subscribe((res) => {
                // this.spinner.hide();
                if (res.status) {
                  res.data.forEach((element) => {
                    if (element.EsType == 'P') {
                      this.EsCodeArr1.push(element);
                      this.filteredListCode1 = this.EsCodeArr1.slice();
                      this.Part = true;
                      this.PaperType = true
                    }
                    if (element.EsType == 'I') {
                      this.EsCodeArr2.push(element);
                      this.filteredListCode2 = this.EsCodeArr2.slice();
                      this.InPart = true;
                    }
                  });
                } else {
                  // this.spinner.hide();
                }
              });
              this.ExamSubForm.get('ESubPart').setValue(res.data[0].EsId);
              this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsParent);
            } else if (res.data[0].EsType == 'S') {
              this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsId);
              this.EsCodeArr1 = [];
              this.EsCodeArr2 = [];
              this.Part = false;
              this.InPart = false;
              payload['EsStrId'] = this.str;
              payload['EsId'] = res.data[0].EsId;
              this.umsService.getSingleRecord(payload).subscribe((res) => {
                // this.spinner.hide();
                if (res.status) {
                  res.data.forEach((element) => {
                    if (element.EsType == 'P') {
                      this.EsCodeArr1.push(element);
                      this.filteredListCode1 = this.EsCodeArr1.slice();
                      this.Part = true;
                      this.PaperType = true
                    }
                    if (element.EsType == 'I') {
                      this.EsCodeArr2.push(element);
                      this.filteredListCode2 = this.EsCodeArr2.slice();
                      this.InPart = true;
                    }
                  });
                } else {
                  // this.spinner.hide();
                }
              });
            }
          });
          this.ExamSubForm.get('ESubInPart').setValue(res.data[0].EsId)
        } else if (res.data[0].EsType == 'P') {
          const payload = {};
          payload['EsParent'] = res.data[0].EsParent;
          payload['EsStrId'] = this.str;
          this.umsService.getParentRecord(payload).subscribe((res) => {
            // this.spinner.hide();
            if (res.data[0].EsType == 'P') {
              this.EsCodeArr1 = [];
              this.EsCodeArr2 = [];
              this.Part = false;
              this.InPart = false;
              payload['EsStrId'] = this.str;
              payload['EsId'] = res.data[0].EsId;
              this.umsService.getSingleRecord(payload).subscribe((res) => {
                // this.spinner.hide();
                if (res.status) {
                  res.data.forEach((element) => {
                    if (element.EsType == 'P') {
                      this.EsCodeArr1.push(element);
                      this.filteredListCode1 = this.EsCodeArr1.slice();
                      this.Part = true;
                      this.PaperType = true
                    }
                    if (element.EsType == 'I') {
                      this.EsCodeArr2.push(element);
                      this.filteredListCode2 = this.EsCodeArr2.slice();
                      this.InPart = true;
                    }
                  });
                } else {
                }
              });
              this.ExamSubForm.get('ESubPart').setValue(res.data[0].EsId);
              this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsParent);
            } else if (res.data[0].EsType == 'I') {
              this.EsCodeArr1 = [];
              this.EsCodeArr2 = [];
              this.Part = false;
              this.InPart = false;
              payload['EsStrId'] = this.str;
              payload['EsId'] = res.data[0].EsId;
              this.umsService.getSingleRecord(payload).subscribe((res) => {
                // this.spinner.hide();
                if (res.status) {
                  res.data.forEach((element) => {
                    if (element.EsType == 'P') {
                      this.EsCodeArr1.push(element);
                      this.filteredListCode1 = this.EsCodeArr1.slice();
                      this.Part = true;
                      this.PaperType = true
                    }
                    if (element.EsType == 'I') {
                      this.EsCodeArr2.push(element);
                      this.filteredListCode2 = this.EsCodeArr2.slice();
                      this.InPart = true;
                    }
                  });
                } else {
                }
              });
              this.ExamSubForm.get('ESubPart').setValue(res.data[0].EsId);
              this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsParent);
            } else if (res.data[0].EsType == 'S') {
              this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsId);
              this.EsCodeArr1 = [];
              this.EsCodeArr2 = [];
              this.Part = false;
              this.InPart = false;
              payload['EsStrId'] = this.str;
              payload['EsId'] = res.data[0].EsId;
              this.umsService.getSingleRecord(payload).subscribe((res) => {
                // this.spinner.hide();
                if (res.status) {
                  res.data.forEach((element) => {
                    if (element.EsType == 'P') {
                      this.EsCodeArr1.push(element);
                      this.filteredListCode1 = this.EsCodeArr1.slice();
                      this.Part = true;
                      this.PaperType = true
                    }
                    if (element.EsType == 'I') {
                      this.EsCodeArr2.push(element);
                      this.filteredListCode2 = this.EsCodeArr2.slice();
                      this.InPart = true;
                    }
                  });
                } else {
                }
              });
            }
          });
          this.ExamSubForm.get('ESubPart').setValue(res.data[0].EsId)
        } else if (res.data[0].EsType == 'S') {
          const payload = {};
          payload['EsParent'] = this.data.value.EsParent;
          payload['EsStrId'] = this.str;
          this.umsService.getParentRecord(payload).subscribe((res) => {
            this.ExamSubForm.get('ESUBID').setValue(res.data[0].EsId);
          });
        }
      });
    }
  }

  showSem() {
    const payload = {};
    payload['SeEmId'] = this.umsService.examData['EmId'];

    this.umsService.getExamSem(payload).subscribe((res) => {
      if (res.status == false) {
        this.Semester = false;
        // this.SemList = res.data;
        // this.filteredListSem = this.SemList.slice();
      } else {
        this.Semester = true;
        this.SemList = res.data;

        this.filteredListSem = this.SemList.slice();
      }
    });
  }

  radio(data) {
  }

  close() {
    this.dialogRef1.close();
  }
  addnewrow() {
    this.optGridAction.push('');
    this.OptionGrid = this.ExamSubForm.get('OptionGrid') as FormArray;
    // alert(1)
    this.OptionGrid.push(
      this.fb.group({
        OpCode: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z]*$')]),
        OpMin: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        OpMax: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        OpSpFlag: new FormControl(''),
        Action: new FormControl(this.data.value.EsOpCode),
      })
    );
    this.countofrow = this.OptionGrid.length;
  }
  // prepopulateOptionGrid(e) {
  //   // this.optGridAction.push('');
  //   this.OptionGrid = this.ExamSubForm.get('OptionGrid') as FormArray;
  //   this.OptionGrid.push(
  //     this.fb.group({
  //       OpCode: new FormControl(e['OpCode'], [Validators.required, Validators.pattern('^[a-zA-Z]*$')]),
  //       OpMin: new FormControl(e['OpMin'], [Validators.required, Validators.pattern('^[0-9]*$')]),
  //       OpMax: new FormControl(e['OpMax'], [Validators.required, Validators.pattern('^[0-9]*$')]),
  //       OpSpFlag: new FormControl(e['OpSpFlag']),
  //       Action: new FormControl(this.data.value.EsOpCode),
  //     })
  //   );
  //   this.countofrow = this.OptionGrid.length;
  // }
  prepopulateOptionGrid(e) {
    // this.optGridAction.push('');

    this.OptionGrid = this.ExamSubForm.get('OptionGrid') as FormArray;
    let actionValue = this.selectedOption ? this.data.value.EsOpCode : '';
    this.OptionGrid.push(
      this.fb.group({
        OpCode: new FormControl(e['OpCode'], [Validators.required, Validators.pattern('^[a-zA-Z]*$')]),
        OpMin: new FormControl(e['OpMin'], [Validators.required, Validators.pattern('^[0-9]*$')]),
        OpMax: new FormControl(e['OpMax'], [Validators.required, Validators.pattern('^[0-9]*$')]),
        OpSpFlag: new FormControl(e['OpSpFlag']),
        Action: new FormControl(actionValue),
      })
    );
    this.selectedOption = this.data.value.EsOpCode;
    this.countofrow = this.OptionGrid.length;
  }
  // checkopcode(OpCode, Action) {
  //   if (OpCode == Action) {
  //     return true
  //   } else {
  //     return false
  //   }

  // }
  addnewMarks(e) {
    this.marksGrid = this.ExamSubForm.get('marksGrid') as FormArray;
    this.marksGrid.push(
      this.fb.group({
        EsQMarksValue: new FormControl(e, Validators.pattern('^[0-9]*$'))
      })
    );
    this.countofrowmarksGrid = this.marksGrid.length;
  }



  addnewDefine() {
    this.DefineGrid = this.ExamSubForm.get('DefineGrid') as FormArray;
    this.DefineGrid.push(
      this.fb.group({
        EsGrd: new FormControl('', [Validators.required, Validators.pattern('^([A-Za-z]\+)|([A-Za-z])$')]),
        EsPass: new FormControl('', Validators.required,),
        EsExm: new FormControl('', Validators.required),
        EsMrk: new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$')])
      })
    );
  }
  preaddnew(e) {
    if (e == '') {
    }

    this.DefineGrid = this.ExamSubForm.get('DefineGrid') as FormArray;
    this.DefineGrid.push(
      this.fb.group({
        EsGrd: new FormControl(e[0], [Validators.pattern('^([A-Za-z]\+)|([A-Za-z])$')]),
        EsPass: new FormControl(e[1]),
        EsExm: new FormControl(e[2]),
        EsMrk: new FormControl(e[3], [Validators.pattern('^[0-9]+$')]),
      })
    );

    let a = this.DefineGrid.value;
    let array = [];
    a.forEach((element, i) => {
      this.a1 =
        element.EsGrd +
        '-' +
        element.EsPass +
        '-' +
        element.EsExm +
        '-' +
        element.EsMrk;
      array.push(this.a1);
    })
  }
  emptyOption() {
    let tempmap = [1, 2, 3];
    this.OptionGrid = this.ExamSubForm.get('OptionGrid') as FormArray;
    tempmap.forEach((element) => {

    });
  }

  emptyDefine() {
    let tempmap = [1, 2, 3, 4, 5];
    tempmap.forEach((element) => { });
  }

  getDefineData() {
    let grades = this.data.value.EsGrades;
    if (grades != '---') {
      let Grd = grades.split(',');
      this.DefineGrid = this.ExamSubForm.get('DefineGrid') as FormArray;
      Grd.forEach((element, i) => {
        let x = element.split('-');
        this.preaddnew(x);
      });

    }
    else {
      // this.addnewDefine();
    }

  }

  getOptionData() {
    this.spinner.show();
    const payload = {};
    this.submitpayload = this.ExamSubForm.value;
    this.umsService.examData['EmId'];
    payload['OpEmId'] = this.umsService.examData['EmId'];
    payload['OpStrId'] = this.str;
    this.umsService.getOption(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.data.length == 0) {
        this.addnewrow();
      } else {
        res.data.forEach(element => {
          this.prepopulateOptionGrid(element)
          // this.addnewrow();
          // this.preaddnew(element);
        });
        // this.optGridAction = [];
        // this.optionList = res.data;
        // this.OptionTable = res.data;
        // this.OptionGrid = this.ExamSubForm.get('OptionGrid') as FormArray;
        // this.OptionTable.map((element, i) => {
        //   this.OptionGrid.at(i).get('OpCode').setValue(element['OpCode']);
        //   this.OptionGrid.at(i).get('OpMin').setValue(element['OpMin']);
        //   this.OptionGrid.at(i).get('OpMax').setValue(element['OpMax']);
        //   this.optGridAction.push(element['OpCode']);
        //   if (this.data.value.EsOpCode == element['OpCode']) {
        //     this.OptionGrid.at(i).get('Action').setValue(this.data.value.EsOpCode);
        //   }
        //   // if (res.data.length == 1) {
        //   //   this.OptionGrid.at(i).get('Action').setValue(element['OpCode']);
        //   // }
        // });
      }
    });

  }


  ListOfAllSubjects() {
    const payload = {};
    this.EsCodeArr = [];
    payload['EsEmId'] = this.umsService.examData['EmId'];
    payload['EsStrId'] = this.str;
    this.umsService.getExamSubjectListFetch(payload).subscribe((res) => {
      res.data.forEach((element, i) => {
        if (element.EsType == 'S') {
          element['checked'] = false;
          this.EsCodeArr.push(element);
          this.cantOffer.push(element);
          this.mustOffer.push(element);
          this.filteredListCode = this.EsCodeArr.slice();
        }
      });
    })
  }

  Subjects() {
    const payload = {};
    payload['EsEmId'] = this.umsService.examData['EmId'];
    payload['EsStrId'] = this.str;
    this.PaperType = false
    this.umsService.getExamSubMapFetch(payload).subscribe((res) => {
      this.PaperType = true
      this.subjects = res.data;

      if ((this.data.value == 'd')) {
        this.ExamSubForm.setValue['EsHOM'] = 'Y';
        this.ValType = true;
        this.UniColg = true;
        this.CarryOver = true;
        this.MaxMarks = true;
        this.PassMarks = true;
        this.PassPercent = true;
      }
      this.ExamSubForm.get('PType')?.setValue(res.data[0].PaperType);
      // else {
      //   res.data.children.forEach((element) => {
      //     if (element.children.length == 0 && element.EsType == 'S') {
      //       this.ExamSubForm.setValue['EsHOM'] = 'Y';
      //       this.ValType = true;
      //       this.UniColg = true;
      //       this.CarryOver = true;
      //       this.MaxMarks = true;
      //       this.PassMarks = true;
      //       this.PassPercent = true;
      //     } else if (element.children.length > 0 && element.EsType == 'P') {
      //       this.ExamSubForm.setValue['EsHOM'] = '';
      //       this.ValType = false;
      //       this.UniColg = false;
      //       this.CarryOver = false;
      //       this.MaxMarks = false;
      //       this.PassMarks = false;
      //       this.PassPercent = false;
      //     }
      //     if (element.children[0].EsType == 'P') {
      //       element.children.forEach((elementP) => {
      //         if(elementP.EsType == 'P'){
      //           this.ExamSubForm.setValue['EsHOM'] = '';
      //           this.ValType = false;
      //           this.UniColg = false;
      //           this.CarryOver = false;
      //           this.MaxMarks = false;
      //           this.PassMarks = false;
      //           this.PassPercent = false;
      //         }
      //         elementP.children.forEach((elementH) => {
      //           if (elementH.length > 0 && elementH.EsType == 'H') {
      //             this.ExamSubForm.setValue['EsHOM'] = 'Y';
      //             this.ValType = true;
      //             this.UniColg = true;
      //             this.CarryOver = true;
      //             this.MaxMarks = true;
      //             this.PassMarks = true;
      //             this.PassPercent = true;
      //           } else if (elementH.length == 0) {
      //             this.ExamSubForm.setValue['EsHOM'] = '';
      //             this.ValType = false;
      //             this.UniColg = false;
      //             this.CarryOver = false;
      //             this.MaxMarks = false;
      //             this.PassMarks = false;
      //             this.PassPercent = false;
      //           }
      //         });
      //       });
      //     }
      //   });
      // }
      this.Seq = res.length;
    });
  }

  Groups() {
    this.EsGroup = [];
    const payload = {};
    payload['EsEmId'] = this.umsService.examData['EmId'];
    payload['EsStrId'] = this.str;
    this.umsService.getExamGroupListFetch(payload).subscribe((res) => {
      this.Group = true;
      this.EsGroup = res.data;
      this.filteredListGroup = this.EsGroup.slice();


    })
  }

  selected(e, msg) {
    if (msg == 'cant' && e.checked == false) {
      e.checked = true;
      for (var i = this.mustOffer.length - 1; i >= 0; --i) {
        if (this.mustOffer[i].EsId == e.EsId) {
          this.mustOffer.splice(i, 1);
        }
      }
    } else if (msg == 'must' && e.checked == false) {
      e.checked = true;
      for (var i = this.cantOffer.length - 1; i >= 0; --i) {
        if (this.cantOffer[i].EsId == e.EsId) {
          this.cantOffer.splice(i, 1);
        }
      }
    } else if (msg == 'cant' && e.checked == true) {
      e.checked = false;
      this.mustOffer.push(e);
    } else if (msg == 'must' && e.checked == true) {
      e.checked = false;
      this.cantOffer.push(e);
    } else {
    }
  }
  GridCondition() { }

  HomConditions() {
    let x = [];
    x.push(this.umsService.secretdata);
    x.forEach((element) => {
      if (element.SubFlds == 'P' || element.SubFlds == 'Q') {
        this.Sec = true;
        this.Marks = true;
      }
    });
  }

  ValTypeData() {
    this.umsService.getValType().subscribe((res) => {
      if (res.status) {
        this.ValTypeList = res.data;
        this.filteredListVal = this.ValTypeList.slice();
      } else {
      }
    });
  }

  showGrade() {
    let payload = {};
    this.Credits = false;
    payload['CoCode'] = this.umsService.courseData['CoCode'];
    this.umsService.getCredit(payload).subscribe((res) => {
      if (
        res.status == true &&
        this.umsService.examData['EmEval'] == 'M'
      ) {
        this.Credits = true;
      }
    });
    if (this.umsService.examData['EmEval'] == 'M') {
      this.GrdBtn = false;
      this.DefBtn = false;
    } else if (this.umsService.examData['EmEval'] == 'GP') {
      this.GrdBtn = true;
      this.DefBtn = true;
      this.Credits = false;
    } else if (this.umsService.examData['EmEval'] == 'GPA') {
      this.GrdBtn = true;
      this.DefBtn = true;
      this.Credits = true;
    } else {
      this.GrdBtn = false;
      this.DefBtn = false;
    }
  }

  showText() {
    if (
      this.ExamSubForm.value['EsGrades'] != '' &&
      this.ExamSubForm.value['EsMarkGrd'] != 'G'
    ) {
      this.Text = true;
    } else {
      this.Text = false;
    }
  }
  // onItemChange(x, i) {
  //   this.OptionGrid = this.ExamSubForm.get('OptionGrid') as FormArray;
  //   this.OptionGrid.at(0).get('Action').setValue(x.value.OpCode);
  //   this.Code = x.value.OpCode;
  // }

  onItemChange(e) {
    let x = e.value;
    this.Code = x.OpCode;
  }
  onMarksGridInput() {
    let examAlert = false;
    let examError = false;
    let EsQMarksValue = 0;
    this.marksGrid = this.ExamSubForm.get('marksGrid') as FormArray;
    let EsMaxMarks = this.ExamSubForm.get('EsMaxMarks').value
    // let EsPartMarks = this.ExamSubForm.get('EsPartMarks').value
    this.marksGrid.value.forEach(element => {
      EsQMarksValue = EsQMarksValue + JSON.parse(element.EsQMarksValue);
      if (element.EsQMarksValue == '' || element.EsQMarksValue == 0) {
        examAlert = true;
      } else {

        if (EsMaxMarks == EsQMarksValue) {
          examError = false;
          examAlert = false;
        } else {
          examError = true;
          examAlert = false;
        }
      }
    });
    if (examAlert !== false) {
      let data = {}
      data['message'] = 'Please Enter All Section Fields'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }
    if (examError !== false) {
      let data = {}
      data['message'] = 'Sum of Section Marks Should Be Equel To Exam Max Marks '
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }
    let push = {}
    push['examAlert'] = examAlert;
    push['examError'] = examError;
    return push;
    // this.marksGrid.controls.forEach(element => {
    // });
    // this.OptionGrid.at(0).get('Action').setValue(x.value.OpCode);
    // this.marksGridValueEsQMarks = ''
    // this.Code = x.value.OpCode;
  }

  setValidor() {
    this.ExamSubForm.get('EsMaxMarks').setValidators([Validators.required]);
  }

  // setPattern(){
  //   this.ExamSubForm.get('EsMaxMarks').setValidators([Validators.required]);
  // }

  removeValidator() {
    this.ExamSubForm.get('EsMaxMarks').clearValidators();
    this.ExamSubForm.get('EsMaxMarks').setValidators(Validators.pattern('^[0-9]*$'));
  }

  submit() {
    if (this.selectedoption === 'S' || this.data.value.EsType === 'S') {
      this.ExamSubForm.get('EsMaxMarks').markAsTouched();
      this.setValidor();
      this.save()
    }
    else {
      // this.ExamSubForm.get('EsMaxMarks').markAsTouched();
      this.removeValidator();
      this.save();

    }
  }
  save() {
    if (
      this.ExamSubForm.get('EsMarkGrd').valid == true &&
      this.ExamSubForm.get('EsCollUni').valid == true &&
      this.ExamSubForm.get('EsDistMarks').valid == true &&
      this.ExamSubForm.get('EsExmMarks').valid == true &&
      this.ExamSubForm.get('EsPassMarks').valid == true &&
      this.ExamSubForm.get('EsMaxMarks').valid == true) {
      // let z = this.passmarksa();
      //  this.checkduplicate();

      let x = this.onMarksGridInput();

      //  && z['pass']== true
      if (x['examAlert'] == false && x['examError'] == false) {

        this.submita();
      }
    } else {

      this.ExamSubForm.get('EsMarkGrd').markAsTouched();
      this.ExamSubForm.get('EsCollUni').markAsTouched();
      this.ExamSubForm.get('EsDistMarks').markAsTouched();
      this.ExamSubForm.get('EsExmMarks').markAsTouched();
      this.ExamSubForm.get('EsPassMarks').markAsTouched();


    }
  }
  showMarkPercentage() {
    if (this.ExamSubForm.value.CDMARKPERCENTAGE == true) {
      this.showMark = false;
      this.showPerc = true;
    } else if (this.ExamSubForm.value.CDMARKPERCENTAGE == true) {
      this.showMark = true;
      this.showPerc = false;
    }
  }
  submita() {
    this.spinner.show();
    let a = this.DefineGrid.value;
    let array = [];
    let barray = [];

    a.forEach((element, i) => {
      if (element.EsGrd == null || element.EsMrk == null || element.EsPass == null || element.EsExm == null) {
      } else {
        if (element.EsPass == 'F') {
          element.EsExm = 'N';
        }
        this.a1 = element.EsGrd + '-' + element.EsPass + '-' + element.EsExm + '-' + element.EsMrk;
        array.push(this.a1);
      }
    });
    let b = this.marksGrid.value;
    b.forEach(element => {
      barray.push(element.EsQMarksValue)
    });
    // 
    this.submitpayload = this.ExamSubForm.value;

    this.submitpayload.PaperType = this.pType ? this.pType : null;
    this.submitpayload.AttendanceRequired = this.ExamSubForm.value.AttendanceRequired;
    this.submitpayload.EsEmId = this.x;
    this.submitpayload.EsStrId = this.str
    this.submitpayload.Inst = this.umsService.secretdata['ClubPartTrans'];
    this.submitpayload.EsType = this.selectedoption;
    this.submitpayload.EsSeq = this.Seq;
    this.submitpayload.EsLevel = this.level;
    this.submitpayload.EsOpCode = this.Code;
    this.submitpayload.EsGrdPts = this.EsGrdPts;
    this.submitpayload.EsQMarks = barray.toString();
    if (this.submitpayload.EsExclTot == true) {
      this.submitpayload.EsExclTot = 'Y'
    }
    else if (this.submitpayload.EsExclTot == false) {
      this.submitpayload.EsExclTot = 'N'
    }
    if (this.data.value.EsType == 'G' || this.selectedoption == 'G') {
      this.submitpayload.EsPSubId = null
    }
    if (this.data.value.EsType == 'S' || this.selectedoption == 'S') {
      if (this.submitpayload.ESubGroup == null) {
        this.submitpayload.EsPSubId = null
      } else {
        this.submitpayload.EsPSubId = this.submitpayload.ESubGroup
      }
    }
    if (this.submitpayload.EsMaxMarks == '' || this.submitpayload.EsMaxMarks == 0) {
      this.submitpayload.EsMaxMarks = 0;
    }
    if (this.submitpayload.EsPassMarks == '' || this.submitpayload.EsPassMarks == 0) {
      this.submitpayload.EsPassMarks = 0;
    }
    if (this.submitpayload.EsExmMarks == '' || this.submitpayload.EsExmMarks == 0) {
      this.submitpayload.EsExmMarks = 0;
    }


    this.submitpayload.EsHOM = 'Y';
    // if (array.length > 0) {
    //   this.submitpayload.EsGrades = array.toString();
    // } else {
    //   this.submitpayload.EsGrades = '';
    // }
    let arrayGrd = array.toString();
    if (array.length > 0) {

      this.submitpayload.EsGrades = array.toString();
    } else {
      this.submitpayload.EsGrades = arrayGrd.replace("---", "");
    }
    this.umsService.addExamSubSetup(this.submitpayload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef1.close();
          // this.ngOnInit();
        });
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        // this.ngOnInit();
      });
    });
  }

  newFub() {
    // pppp
  }
  update() {
    this.spinner.show();
    let a = this.DefineGrid.value;
    let array = [];
    let barray = [];
    a.forEach((element, i) => {
      if (element.EsGrd == null || element.EsMrk == null || element.EsPass == null || element.EsExm == null) {
      } else {
        if (element.EsPass == 'F') {
          element.EsExm = 'N';
        }
        this.a1 = element.EsGrd + '-' + element.EsPass + '-' + element.EsExm + '-' + element.EsMrk;
        array.push(this.a1);
      }
    });
    let b = this.marksGrid.value;
    b.forEach(element => {
      barray.push(element.EsQMarksValue)
    });
    let arrayGrades = array.toString();
    this.submitpayload = this.ExamSubForm.value;
    this.submitpayload.PaperType = this.submitpayload.PType;
    // this.submitpayload.AttendanceRequired = this.submitpayload.AttendanceRequired;
     this.submitpayload.AttendanceRequired = this.ExamSubForm.value.AttendanceRequired;;
    this.submitpayload.EsEmId = this.x;
    this.submitpayload.EsStrId = this.str
    this.submitpayload.EsType = this.selectedoption;
    //this.submitpayload.EsSeq = this.Seq;
    this.submitpayload.EsLevel = this.level;
    this.submitpayload.EsHOM = 'Y';
    this.submitpayload.EsOpCode = this.selectedOption;
    this.submitpayload.EsGrades = arrayGrades.replace(",---", "");
    this.submitpayload.EsGrdPts = this.EsGrdPts;
    this.submitpayload.EsQMarks = barray.toString();
    if (this.submitpayload.EsExclTot == true) {
      this.submitpayload.EsExclTot = 'Y'
    }
    else if (this.submitpayload.EsExclTot == false) {
      this.submitpayload.EsExclTot = 'N'
    }
    if (this.submitpayload.EsPass == 'F') {
      this.submitpayload.EsExm = 'N';
    }
    this.umsService.updateExamSubSetup(this.submitpayload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          // this.ngOnInit();
          this.dialogRef1.close();
        });

      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    });
  }
  PassValue(e, i) {
    let control = (<FormArray>this.ExamSubForm.get('DefineGrid')).at(i);
    if (e == 'F') {
      control.patchValue({
        EsExm: 'N',
      });
    }
  }
  ExamValue(e, i) {
    let control = (<FormArray>this.ExamSubForm.get('DefineGrid')).at(i);
    if (this.DefineGrid.at(i).get('EsPass').value == 'F') {
      control.patchValue({
        EsExm: 'N',
      });
    }
  }

  subjectSelect(e) {
    let payload = {};
    this.EsCodeArr1 = [];
    this.EsCodeArr2 = [];
    payload['EsStrId'] = this.str;
    payload['EsId'] = e.EsId;
    this.Part = false;
    this.InPart = false;
    if (e.EsParent !== 0) {
      this.ExamSubForm.get('EsPSubId').setValue(e.EsParent);
    } else {
      this.ExamSubForm.get('EsPSubId').setValue(e.EsId);
    }
    this.setgroupParentID(e.EsId)
    this.umsService.getSingleRecord(payload).subscribe((res) => {
      if (res.status) {
        res.data.forEach((element) => {
          if (element.EsType == 'P') {
            this.EsCodeArr1.push(element);
            this.filteredListCode1 = this.EsCodeArr1.slice();
            this.Part = true;
            this.PaperType = true
          }
          if (element.EsType == 'I') {
            this.EsCodeArr2.push(element);
            this.filteredListCode2 = this.EsCodeArr2.slice();
            this.InPart = true;
          }
        });
      } else {
      }
    });
  }

  singleRecordPart(e) {
    let payload = {};
    this.EsCodeArr1 = [];
    this.EsCodeArr2 = [];
    payload['EsStrId'] = this.str;
    payload['EsId'] = e;
    this.Part = false;
    this.InPart = false;
    this.setgroupParentID(e)
    this.umsService.getSingleRecord(payload).subscribe((res) => {
      if (res.status) {
        res.data.forEach((element) => {
          if (element.EsType == 'P') {
            this.EsCodeArr1.push(element);
            this.filteredListCode1 = this.EsCodeArr1.slice();
            this.Part = true;
          }
          if (element.EsType == 'I') {
            this.EsCodeArr2.push(element);
            this.filteredListCode2 = this.EsCodeArr2.slice();
            this.InPart = true;
          }
        });
      } else {
      }
    });
  }
  marksInput() {
    let count = this.ExamSubForm.get('EsPartMarks').value
    this.marksGrid = this.ExamSubForm.get('marksGrid') as FormArray;
    this.marksGrid.clear();
    for (let index = 0; index < count; index++) {
      this.addnewMarks(0);
    }
  }
  marksprepopulate(e) {
    const myArray = e.split(",");
    let count = this.ExamSubForm.get('EsPartMarks').value
    this.marksGrid = this.ExamSubForm.get('marksGrid') as FormArray;
    this.marksGrid.clear();
    for (let index = 0; index < count; index++) {
      this.addnewMarks(myArray[index]);
    }
  }
  singleRecordInPart(e) {
    let payload = {};
    this.EsCodeArr2 = [];
    payload['EsStrId'] = this.str;
    payload['EsId'] = e;
    this.setgroupParentID(e)
    this.umsService.getSingleRecord(payload).subscribe((res) => {
      if (res.status) {
        this.PaperType = true
        this.ExamSubForm.get('PType')?.setValue(res.data[0].PaperType);
        res.data.forEach((element) => {
          if (element.EsType == 'I') {
            this.InPart = true;
            this.PaperType = true;
            this.EsCodeArr2.push(element);
            this.filteredListCode2 = this.EsCodeArr2.slice();
          }
        });
      } else {
      }
    });
  }


  markasDefault(e) {
    if (e == true) {
      let grades = "Def-P-E-100";
      let Grd = grades.split(',');
      this.DefineGrid = this.ExamSubForm.get('DefineGrid') as FormArray;
      if (this.DefineGrid.controls.length == 1) {
        this.DefineGrid.clear();
        Grd.forEach((element, i) => {
          let x = element.split('-');
          this.preaddnew(x)
        });
      } else {
        Grd.forEach((element, i) => {
          let x = element.split('-');
          this.preaddnew(x)
        });
      }
    }
  }
  openSubjectGradePointsPopUP() {
    let data = {};
    data['EmId'] = this.umsService.examData['EmId'];
    data['value'] = '';

    this.dialogRefGradePoints = this.dialog.open(ExamSubjectGradepointsPopComponent, {
      width: "500px",
      height: "auto",
      data,
    });
    this.dialogRefGradePoints.afterClosed().subscribe(res => {
      this.EsGrdPts = res.data.EsGrdPts;// received data from confirm-component
    });
  }
  passmarks() {

  }
  passmarksa() {
    let maxMarks = this.ExamSubForm.get('EsMaxMarks').value;
    let passMarks = this.ExamSubForm.get('EsPassMarks').value;
    let examMarks = this.ExamSubForm.get('EsExmMarks').value;
    let distMarks = this.ExamSubForm.get('EsDistMarks').value;
    let approve = true;
    if (JSON.parse(passMarks) > JSON.parse(maxMarks)) {
      approve = false;
      let data = {}
      data['message'] = 'Pass Marks Cant be Greater Than Max-Marks'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    } else if (JSON.parse(examMarks) > JSON.parse(maxMarks)) {
      approve = false;
      let data = {}
      data['message'] = 'Exam Marks Cant be Greater Than Max-Marks'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    } else if (JSON.parse(distMarks) > JSON.parse(maxMarks)) {
      approve = false;
      let data = {}
      data['message'] = 'Distinction Marks Cant be Greater Than Max-Marks'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }
    let passmarksa = {}
    passmarksa['pass'] = approve;
    return passmarksa;
  }


  addNewBtn() {
    this.OptionGrid = this.ExamSubForm.get('OptionGrid') as FormArray;
    if (this.OptionGrid.invalid) {
      this.OptionGrid.controls.forEach(element => {
        // element.get('OpCode').markAsTouched();
        // element.get('OpMin').markAsTouched();
        // element.get('OpMax').markAsTouched();

      })
    } else {
      this.addnewrow()
    }

  }



  checkduplicate() {
    var BreakException = {};
    // let gCode = this.grpCode;
    let data = this.data.SubData
    let GroupData = []
    let SubData = []
    let Head = []
    let InPart = []
    data.forEach(element => {
      if (element.EsType == 'G') {
        GroupData.push(element)
      }
      else if (element.EsType == 'S') {
        SubData.push(element)
      }
    });
    GroupData.forEach(element => {
      element.children.forEach(element1 => {
        if (element1.EsType == 'S') {
          SubData.push(element1)
        }
      });
    });
    let subject = SubData.find(item => item.EsId == this.ExamSubForm.value.ESUBID);
    subject.children.forEach(element => {
      if (this.selectedoption == 'P') {
        if (element.EsCode == this.ExamSubForm.value.EsCode) {
          let data = {}
          data['message'] = "Part Code Exist"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            this.ExamSubForm.controls['EsCode'].setValue('');
          })
        }
      }
      element.children.forEach(element2 => {
        if (element2.EsType == 'H') {
          Head.push(element2)
        }
        else if (element2.EsType == 'I') {
          InPart.push(element2)
          element2.children.forEach(element3 => {
            if (element3.EsType == 'H') {
              Head.push(element3)
            }
          });
        }
      });
      if (this.selectedoption == 'H') {
        if (element.EsCode == this.ExamSubForm.value.EsCode) {
          let data = {}
          data['message'] = "Head Code Exist"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            this.ExamSubForm.controls['EsCode'].setValue('');
          })
        }
      }

    });
    Head.forEach(element => {
      if (this.selectedoption == 'H') {
        if (element.EsCode == this.ExamSubForm.value.EsCode) {
          let data = {}
          data['message'] = "Head Code Exist"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            this.ExamSubForm.controls['EsCode'].setValue('');
          })
        }
      }
    });

    InPart.forEach(element => {
      if (this.selectedoption == 'I') {
        if (element.EsCode == this.ExamSubForm.value.EsCode) {
          let data = {}
          data['message'] = "InPart Code Exist"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            this.ExamSubForm.controls['EsCode'].setValue('');
          })
        }
      }
    });
    if (this.selectedoption == 'G') {
      GroupData.forEach(element => {
        if (this.ExamSubForm.value.EsCode == element.EsCode) {
          let data = {}
          data['message'] = "Group Code Exist"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            this.ExamSubForm.controls['EsCode'].setValue('');
          })
        }
      });
    }



    // if (this.selectedoption == 'G') {
    //   gCode.forEach(async (element) => {

    //     if (this.ExamSubForm.value.EsCode == element) {
    //       let data = {}
    //       data['message'] = "Group Code Exist"
    //       data['title'] = 'Information'
    //       data['icon'] = 'fas fa-check'
    //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //       this.dialogRef.afterClosed().subscribe(result => {
    //         this.ExamSubForm.controls['EsCode'].setValue('');
    //       })
    //     }

    //   },)
    // }
    // else if (this.selectedoption == 'P') {
    //   this.subjects.children.forEach(async (element) => {
    //       if (element.EsId == this.ExamSubForm.value.ESUBID) {
    //         element.children.forEach(element1 => {
    //           if (this.ExamSubForm.value.EsCode == element1.EsCode) {
    //             let data = {}
    //             data['message'] = "Part Code Exist Under Same Subject"
    //             data['title'] = 'Information'
    //             data['icon'] = 'fas fa-check'
    //             this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //             this.dialogRef.afterClosed().subscribe(result => {
    //               this.ExamSubForm.controls['EsCode'].setValue('');
    //             })
    //           }
    //         });
    //       }



    //   })
    // }
    // else if (this.selectedoption == 'I') {
    //   this.subjects.children.forEach(async (element) => {
    //       if (element.EsId == this.ExamSubForm.value.ESUBID) {
    //         element.children.forEach(element1 => {
    //           if (this.ExamSubForm.value.ESubPart == '' || this.ExamSubForm.value.ESubPart == null) {
    //             if (this.ExamSubForm.value.EsCode == element1.EsCode) {
    //               let data = {}
    //               data['message'] = "InPart Code Exist Under Same Subject"
    //               data['title'] = 'Information'
    //               data['icon'] = 'fas fa-check'
    //               this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //               this.dialogRef.afterClosed().subscribe(result => {
    //                 this.ExamSubForm.controls['EsCode'].setValue('');
    //               })
    //             }

    //           }
    //           else {
    //             element1.children.forEach(element2 => {
    //               if (this.ExamSubForm.value.EsCode == element2.EsCode) {
    //                 let data = {}
    //                 data['message'] = "InPart Code Exist Under Same Subject"
    //                 data['title'] = 'Information'
    //                 data['icon'] = 'fas fa-check'
    //                 this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //                 this.dialogRef.afterClosed().subscribe(result => {
    //                   this.ExamSubForm.controls['EsCode'].setValue('');
    //                 })
    //               }
    //             });
    //           }
    //         });
    //       }
    //   })
    // }
    // else if (this.selectedoption == 'H') {
    //   this.subjects.children.forEach(async (element) => {

    //   element.children.forEach(element1 => {
    //         if (this.ExamSubForm.value.ESUBID == element.EsId  && this.ExamSubForm.value.ESubInPart == null && this.ExamSubForm.value.ESubPart == null) {
    //           if (this.ExamSubForm.value.EsCode == element1.EsCode) {
    //             let data = {}
    //             data['message'] = "Head Code Exists"
    //             data['title'] = 'Information'
    //             data['icon'] = 'fas fa-check'
    //             this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //             this.dialogRef.afterClosed().subscribe(result => {
    //               this.ExamSubForm.controls['EsCode'].setValue('');
    //             })
    //           }
    //         }
    //         else if (this.ExamSubForm.value.ESUBID == element.EsId  && (this.ExamSubForm.value.ESubInPart == null || this.ExamSubForm.value.ESubInPart == '') && this.ExamSubForm.value.ESubPart != null) {

    //           element1.children.forEach(element2 => {
    //              if (this.ExamSubForm.value.EsCode == '' && this.ExamSubForm.value.EsCode == element2.EsCode ) {
    //               let data = {}
    //               data['message'] = "Head Code Exist Under part"
    //               data['title'] = 'Information'
    //               data['icon'] = 'fas fa-check'
    //               this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //               this.dialogRef.afterClosed().subscribe(result => {
    //                 this.ExamSubForm.controls['EsCode'].setValue('');
    //               })
    //             }
    //           });
    //         }
    //         else if (this.ExamSubForm.value.ESUBID == element.EsId  &&  this.ExamSubForm.value.ESubInPart != null && this.ExamSubForm.value.ESubPart == null) {
    //           element1.children.forEach(element2 => {
    //             if (this.ExamSubForm.value.EsCode == element2.EsCode) {
    //               let data = {}
    //               data['message'] = "Head Code Exist Under part"
    //               data['title'] = 'Information'
    //               data['icon'] = 'fas fa-check'
    //               this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //               this.dialogRef.afterClosed().subscribe(result => {
    //                 this.ExamSubForm.controls['EsCode'].setValue('');
    //               })
    //             }
    //           });

    //         }
    //         else if (this.ExamSubForm.value.ESUBID == element.EsId  &&  this.ExamSubForm.value.ESubInPart != null && this.ExamSubForm.value.ESubPart != null) {
    //           element1.children.forEach(element2 => {
    //             element2.children.forEach(element3 => {
    //               if (this.ExamSubForm.value.EsCode == element3.EsCode) {
    //                 let data = {}
    //                 data['message'] = "Head Code Exist Under part"
    //                 data['title'] = 'Information'
    //                 data['icon'] = 'fas fa-check'
    //                 this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //                 this.dialogRef.afterClosed().subscribe(result => {
    //                   this.ExamSubForm.controls['EsCode'].setValue('');
    //                 })
    //               }
    //             });

    //           });


    //         }
    //       });


    //   })
    // }
  }

  // exit(){
  //   let gCode = this.grpCode;
  //   const newArray = [];
  //   const array = [

  //   ];
  //   try {
  //     gCode.forEach(element => {
  //       if (this.ExamSubForm.value.EsCode == element) {
  //         throw new Error("Condition matched. Exiting loop.");
  //       }
  //       // Other loop operations

  //     });
  //   } catch (error) {
  //     // Handle the exception (optional)
  //   }
  // }

  checkduplicateSubCode() {
    let sCode = this.subCodee;
    let gCode = this.grpCode;
    let subCodeUGrop = this.subCodeUnderGroup;
    if (this.selectedoption == 'S') {
      if (this.ExamSubForm.value.ESubGroup != null) {
        this.subjects.children.forEach(async (element) => {
          if (element.EsId == this.ExamSubForm.value.ESubGroup) {
            element.children.forEach(element => {
              if (this.ExamSubForm.value.EsCode == element.EsCode) {
                let data = {}
                data['message'] = "Subject Code Exist Under Same Group"
                data['title'] = 'Information'
                data['icon'] = 'fas fa-check'
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
                this.dialogRef.afterClosed().subscribe(result => {
                  this.ExamSubForm.controls['EsCode'].setValue('');
                })
              }
            });

          }

        })
      }
      else {
        this.subCodee.forEach(element => {
          if (this.ExamSubForm.value.EsCode == element) {
            let data = {}
            data['message'] = "Subject Code Exist"
            data['title'] = 'Information'
            data['icon'] = 'fas fa-check'
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            this.dialogRef.afterClosed().subscribe(result => {
              this.ExamSubForm.controls['EsCode'].setValue('');
            })
          }
        })
      }
    }
  }

  addDefineGrdBtn() {
    this.DefineGrid = this.ExamSubForm.get('DefineGrid') as FormArray;
    if (this.DefineGrid.invalid) {

      this.DefineGrid.controls.forEach(element => {
        // element.get('OpCode').markAsTouched();
        // element.get('OpMin').markAsTouched();
        // element.get('OpMax').markAsTouched();

      })
    } else {
      this.addnewDefine()
    }

  }

  deleteRow(index) {
    if (index != 0) {
      (<FormArray>this.ExamSubForm.get("DefineGrid")).removeAt(index);
    } else {
      let data = {}
      data['message'] = "First Row Can Not Be Deleted"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    }

  }

  deleteOptionGrid(index, option, length: number) {
    let arrayy = this.ExamSubForm.get('OptionGrid') as FormArray
    if (arrayy.length > 1) {
      if (option.value.OpSpFlag == '') {
        (<FormArray>this.ExamSubForm.get("OptionGrid")).removeAt(index);
      } else {
        let data = {}
        data['message'] = "This Option Code Can Not Be Deleted"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    }
    else {
      if (option.value.OpSpFlag == '') {
        let arrayy = this.ExamSubForm.get('OptionGrid') as FormArray
        arrayy.at(index).get('OpCode').setValue('');
        arrayy.at(index).get('OpMin').setValue('');
        arrayy.at(index).get('OpMax').setValue('');
        arrayy.at(index).get('OpSpFlag').setValue('');
        // (<FormArray>this.ExamSubForm.get("OptionGrid")).removeAt(index);
      } else {
        let data = {}
        data['message'] = "This Option Code Can Not Be Deleted"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }


    }

  }

  delete() {
    const data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.deletedata(this.ExamSubForm.value);
      } else {
        // this.ngOnInit();
      }
    });
  }
  deletedata(id) {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        // Inst: id.Inst,
        EsId: id.EsId,
        // EsStrId: id.EsStrId,
        // EsEmId: id.EsEmId,
        // EsLevel: id.EsLevel,
        // EsSeq: id.EsSeq,
        // EsType: id.EsType,
        // EsCode: id.EsCode,
        // EsShName: id.EsShName,
        // EsLang: id.EsLang,
        // EsName: id.EsName,
        // ESubOption: id.ESubOption,
        // EsPrint: id.EsPrint,
        // ESubParent: id.ESubParent,
        // EsCombCode: id.EsCombCode,
        // EsNoComb: id.EsNoComb,
        // EsPSubId: id.EsPSubId,
        // EsParent: id.EsParent,
        // ESubPart: id.ESubPart,
        // ESubInPart: id.ESubInPart,
        // ESubGroup: id.ESubGroup,
        // EsCoType: id.EsCoType,
        // EsThPr: id.EsThPr,
        // EsSubTot: id.EsSubTot,
        // EsSeSr: id.EsSeSr,
        // EsOldCode: id.EsOldCode,
        // EsMarkGrd: id.EsMarkGrd,
        // EsCollUni: id.EsCollUni,
        // EsACF: id.EsACF,
        // EsExclTot: id.EsExclTot,
        // EsSpFlag: id.EsSpFlag,
        // EsMaxMarks: id.EsMaxMarks,
        // EsPartMarks: id.EsPartMarks,
        // EsQMarks: id.EsQMarks,
        // EsPassMarks: id.EsPassMarks,
        // EsPassPC: id.EsPassPC,
        // EsExmMarks: id.EsExmMarks,
        // EsExmPC: id.EsExmPC,
        // EsMustPass: id.EsMustPass,
        // EsDistMarks: id.EsDistMarks,
        // EsDistPC: id.EsDistPC,
        // EsDistRem: id.EsDistRem,
        // EsHOM: id.EsHOM,
        // EsCredit: id.EsCredit,
        // EsGrdPts: id.EsGrdPts,
        // EsDeAct: id.EsDeAct,
        // EsGrades: id.EsGrades,
        // CDMARKPERCENTAGE: id.CDMARKPERCENTAGE,
        // ESUBID: id.ESUBID,
        // EsOpCode: id.EsOpCode,
        // OptionGrid: id.OptionGrid,
        // DefineGrid: id.DefineGrid,
        // marksGrid: id.marksGrid,
        // LoginId: id.LoginId,
      },
    };
    this.httpClient.delete(this.APIService + '/masters/exam-subject', options)
      .subscribe((s) => {
        this.spinner.hide();
        // this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          // this.ngOnInit();
          this.dialogRef1.close();
        });
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          // this.ngOnInit();
          this.dialogRef1.close();
        });
        // this.umsService.openSnackbar(ERROR.error.message);

      });

  }
  isDisabled(option: any): boolean {
    const opSpFlag = option.get('OpSpFlag')?.value;
    const opCode = option.get('OpCode')?.value;

    return ((this.selectedOption === 'S' && opSpFlag === 'G') || (this.Type === 'S' && opSpFlag === 'G')) || !opCode;
  }

  isChecked(option: any): boolean {
    // return this.selectedOption = option.value.OpCode
    return this.checkopcode(option.value.OpCode, this.selectedOption);

  }
  onCheckboxChange(option: any, rowIndex: number, isChecked: boolean): void {
    if (isChecked) {
      this.selectedRowIndex = rowIndex;
      let x = option.value;
      this.Code = x.OpCode;
      this.selectedOption = option.value.OpCode;
    } else {
      this.Code = ''; // Clear the value
      this.selectedOption = ''; // Clear the value
    }
  }

  checkopcode(OpCode, Action) {
    if (OpCode == Action) {
      return true
    } else {
      return false
    }

  }

  openDefGrid() {

  }



  onInputChange(val, index) {
    const tempData = val.target.value;
    const OptionGrid = this.ExamSubForm.get('OptionGrid') as FormArray;
    this.codeArray = OptionGrid.controls.map(control => control.get('OpCode').value);
    // const isDuplicate = this.codeArray.some((item: any) => item === tempData);
    const isDuplicate = this.codeArray.some((item, idx) => idx !== index && item === tempData);
    if (!isDuplicate) {
      this.codeArray[index] = tempData;
      return;
    }

    let data = {
      message: "Option Code Already Used",
      title: 'Information',
      icon: 'fas fa-box-open'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    OptionGrid.controls[index].get('OpCode').setValue('');
  }

  fetchPaperType() {
    const payload = {};
    payload['CdType'] = 'PT';
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.paperTypeList = res.data;
        this.paperTypeListData = this.paperTypeList.slice();
      } else {
        this.paperTypeList = [];
        this.paperTypeListData = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      // this.HeadList = [];
      this.paperTypeListData = [];
    });
  }

  paperTypeSelect(e: any) {
    this.pType = e.CdCode
  }
}

